module.exports = __webpack_public_path__ + "i18n/pt-BR.fc2dcb081b0d592b5be978f97ffe49ff.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=i18n/[name].[hash].[ext]!./i18n/pt-BR.json
// module id = 1291
// module chunks = 60